<template>
  <div>
    <h1>{{ pageHeader }}</h1>

    <form class="lihavapp-form">
      <div class="form-group">
        <label for="WeighingResultScale">Body weight in kilograms</label>
        <input
          type="number"
          class="form-control"
          id="weight"
          name="weight"
          placeholder
          v-model.number="weight"
          required
          :disabled="showModeActive"
        />
      </div>
      <div class="form-group">
        <div class="form-check">
          <input
            class="form-check-input"
            type="checkbox"
            v-model="fasted"
            id="fasted"
            name="fasted"
            :disabled="showModeActive"
          />
          <label class="form-check-label" for="fasted">Fasted measurement (e.g. morning measurement)</label>
        </div>
      </div>

      <div class="form-group">
        <label for="WeighingResultScale">Scale (optional)</label>
        <select
          class="form-control"
          id="WeighingResultScale"
          v-model="selectedScaleId"
          :disabled="showModeActive"
        >
          <option
            v-for="scale in store.state.scales"
            v-bind:key="scale.id"
            v-bind:value="scale.id"
          >{{ scale.manufacturer }} {{ scale.model }}</option>
        </select>
      </div>

      <section>
        <div class="form-group">
          <label for="date">Weighing date</label>
          <input
            type="date"
            v-model="date"
            class="form-control"
            placeholder="Select date"
            :disabled="showModeActive"
          />
        </div>

        <div class="form-group">
          <label>Weighing time (optional)</label>
          <div class="input-group mb-3">
            <input
              type="time"
              class="form-control"
              id="time"
              name="time"
              placeholder
              v-model="time"
              required
              :disabled="showModeActive"
              step="60"
            />
            <div class="input-group-append">
              <button
                class="btn btn-outline-secondary"
                type="button"
                v-on:click="clearTime()"
                :disabled="showModeActive"
              >Clear</button>
            </div>
          </div>
        </div>

        <div class="form-group">
          <label>Comment (optional)</label>
          <input
            class="form-control"
            type="text"
            name="comment"
            v-model="comment"
            :disabled="showModeActive"
          />
        </div>
      </section>

      <div class="form-group lihavapp-form-control-button-holder">
        <button
          type="button"
          class="btn btn-primary mr-3"
          v-on:click="create()"
          v-if="createModeActive"
        >Create</button>

        <button
          type="button"
          class="btn btn-secondary mr-3"
          v-on:click="update()"
          v-if="editModeActive"
        >Update</button>

        <button
          type="button"
          class="btn btn-outline-secondary"
          v-on:click="cancel()"
          v-if="createModeActive || editModeActive"
        >Cancel</button>

        <button
          type="button"
          class="btn btn-outline-danger float-right"
          v-on:click="deleteMeasurement"
          v-if="editModeActive"
        >Delete</button>

        <button
          type="button"
          class="btn btn-secondary"
          v-on:click="$router.push({ name: 'weight' });"
          v-if="showModeActive"
        >Back</button>

        <button
          type="button"
          class="btn btn-outline-secondary float-right"
          v-on:click="edit()"
          v-if="showModeActive"
        >Edit measurement</button>
      </div>

      <div class="form-group lihavapp-form-control-button-holder"></div>
    </form>
  </div>
</template>

<script>
import { store } from "@/store.js";

export default {
  name: "WeightShowCreateEdit",
  components: {},
  data: function() {
    return {
      store: store,
      weight: null,
      comment: "",
      weighingResult: {
        weight: "",
        time: "",
        date: "",
        scale_id: null
      },
      selectedScaleId: null,
      date: this.moment().format("YYYY-MM-DD"),
      time: this.moment().format("HH:mm"),
      fasted: true,
      showScaleInfo: true
    };
  },
  created: function() {
    this.store.fetchScales();
  },
  mounted: function() {
    if (this.showModeActive || this.editModeActive) {
      // this.weighingResult = this.editedObject;
      let object = this.store.getWeighingResult(this.$route.params.id);

      if (object == undefined) {
        return;
      }

      this.weight = (object.weight/1000).toFixed(1);

      this.selectedScaleId = object.scale_id;

      this.date = this.moment(object.date).format("YYYY-MM-DD");

      if (object.time)
        this.time = this.moment(object.time, "HH:mm:ss").format("HH:mm");
      else this.time = null;

      this.comment = object.comment;

      this.fasted = object.fasted;
    }
  },
  computed: {
    showModeActive: function() {
      return this.$route.name == "weight.show";
    },
    createModeActive: function() {
      return this.$route.name == "weight.create";
    },
    editModeActive: function() {
      return this.$route.name == "weight.edit";
    },
    pageHeader: function() {
      if (this.showModeActive) {
        return "Show weighing result";
      }

      if (this.editModeActive) {
        return "Edit weighing result";
      }

      return "Add new weighing result";
    }
  },
  methods: {
    updateWeighingResultObject: function() {
      this.weighingResult.weight = Math.round(this.weight*1000);

      this.weighingResult.time = this.time;

      this.weighingResult.date = this.date;

      this.weighingResult.scale_id = this.selectedScaleId;
      this.weighingResult.comment = this.comment;
      this.weighingResult.fasted = this.fasted;
    },
    create: function() {
      this.updateWeighingResultObject();

      let self = this;
      this.axios
        .post("/weight", this.weighingResult)
        .then(function(response) {
          let measurement = response.data;
          self.store.addWeighingResult(measurement);
          self.flashSuccess("New weighing result stored successfully");
          self.$router.push({ name: "weight" });
        })
        .catch(function(error) {
          self.flashError(error.response.data.message);
        })
        .then(function() {
          // always executed
        });
    },
    edit: function() {
      this.$router.push({
        name: "weight.edit",
        params: { id: this.$route.params.id }
      });
    },
    update: function() {
      this.updateWeighingResultObject();

      let self = this;
      this.axios
        .put("/weight/" + this.$route.params.id, this.weighingResult)
        .then(function(response) {
          let updated = response.data;

          if (self.store.updateWeighingResult(updated)) {
            self.flashSuccess("Weighing result updated successfully");
            self.$router.push({ name: "weight" });
          } else {
            self.flashError("Failed to update weighing result data structure");
          }
        })
        .catch(function(error) {
          self.flashError(error.response.data.message);
        })
        .then(function() {
          // always executed
        });
    },
    cancel: function() {
      if (this.editModeActive) {
        this.$router.push({
          name: "weight.show",
          params: { id: this.$route.params.id }
        });
      } else {
        let returnRoute = "weight";

        if (this.store.state.weightView.cancelRoute)
        {
          returnRoute = this.store.state.weightView.cancelRoute;
        }
        
        this.$router.push({ name: returnRoute });
      }
    },

    deleteMeasurement: function() {
      if (!this.editModeActive) return;

      let measurement = this.store.getWeighingResult(this.$route.params.id);

      if (measurement == undefined) {
        return;
      }
      let confirmationText =
        "Are you sure that you want to delete this weighing result?";

      if (!confirm(confirmationText)) {
        return;
      }

      var self = this;
      this.axios
        .delete("/weight/" + measurement.id)
        .then(function(response) {
          // handle success
          let removed = self.store.removeWeighingResult(measurement.id);

          if (removed) {
            self.flashSuccess("Weighing result deleted successfully");
          } else {
            self.flashSuccess(
              "Weighing result removed from server, but deleting from local data structure failed"
            );
          }

          self.$router.push({ name: "weight" });
        })
        .catch(function(error) {
          self.flashError(error.response.data.message);
        })
        .then(function() {
          // always executed
        });
    },
    clearTime: function() {
      this.time = "";
    },
    selectFirstScale: function() {
      let firstScale = this.store.getFirstScale();

      if (firstScale) {
        this.selectedScaleId = firstScale.id;
      }
    }
  }
};
</script>

<style scoped>
</style>